import React from 'react'
import { useSelector } from 'react-redux'
import { ReduxState } from '../../../store/reducers'
import { IntegrationType } from '../../../@types/config'

export const HIGHLIGHTED_MAP_SEARCH_ICON_URL =
  'https://www.static-immobilienscout24.de/statpic/sales-journey/hos/rle-wizard/icons/870a3fb7a94705501fecf481e280d972_highlightedMapSearch.svg'
export const NEUTRAL_MAP_SEARCH_ICON_URL =
  'https://www.static-immobilienscout24.de/statpic/sales-journey/hos/rle-wizard/icons/0fc6d1d3f173db9b06faa3c6a6bdcb01_neutralMapSearch.svg'

const renderIcon = (integrationType: IntegrationType) => {
  switch (integrationType) {
    case IntegrationType.IMMOBILIENSCOUT24:
      return <img src={HIGHLIGHTED_MAP_SEARCH_ICON_URL} width={128} height={128} alt={''} />
    default:
      return <img src={NEUTRAL_MAP_SEARCH_ICON_URL} width={128} height={128} alt={''} />
  }
}

export const RadiusStepIcon: React.FC = () => {
  const integrationType = useSelector((state: ReduxState) => state.config.integrationType)

  return <div className='icon-container'>{renderIcon(integrationType)}</div>
}
